import {
  DEFAULT_HEADING_LEVEL,
  clampHeadingLevel,
  headingLevelContext,
  s
} from "./chunk.N6SQZYGL.js";
import {
  jb_heading_css_default
} from "./chunk.MWXYZZ5Q.js";
import {
  s as s2,
  u
} from "./chunk.MG3UUVYL.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-heading/jb-heading.ts
var JbHeading = class extends i {
  constructor() {
    super(...arguments);
    this.offset = 0;
    this._headingContext = new s(this, {
      context: headingLevelContext,
      subscribe: true
    });
  }
  render() {
    const inheritedLevel = this._headingContext.value ?? DEFAULT_HEADING_LEVEL;
    const level = clampHeadingLevel(this.rank ?? inheritedLevel + (this.offset ?? 0));
    const tag = `h${level.toString()}`;
    const content = this.text ?? u`<slot></slot>`;
    return u`<${s2(tag)} part="heading" data-variant="${this.variant ?? A}">${content}</${s2(tag)}>`;
  }
};
JbHeading.styles = [reset_css_default, jb_heading_css_default];
__decorateClass([
  n({ type: Number })
], JbHeading.prototype, "offset", 2);
__decorateClass([
  n({ type: Number })
], JbHeading.prototype, "rank", 2);
__decorateClass([
  n()
], JbHeading.prototype, "text", 2);
__decorateClass([
  n()
], JbHeading.prototype, "variant", 2);
JbHeading = __decorateClass([
  customElement("jb-heading")
], JbHeading);

export {
  JbHeading
};
